import { request } from './core.api';

export interface RentalPaymentMonthDto {
  year: number;
  month: number;
  status?: string;
  paidOn?: string;
  note?: string;
  updatedAt?: string;
}

export interface SaveRentalPaymentLogRequest {
  year: number;
  month: number;
  status?: string;
  paidOn?: string;
  note?: string;
}

export const rentalPaymentLogsApi = {
  getByAgreement: (rentalAgreementId: string, months = 12, endYear?: number, endMonth?: number) => {
    const query = new URLSearchParams({ months: String(months) });
    if (endYear != null && endMonth != null) {
      query.set('endYear', String(endYear));
      query.set('endMonth', String(endMonth));
    }

    return request<RentalPaymentMonthDto[]>(`/rental-agreements/${rentalAgreementId}/payment-logs?${query.toString()}`);
  },
  save: (rentalAgreementId: string, data: SaveRentalPaymentLogRequest) =>
    request<void>(`/rental-agreements/${rentalAgreementId}/payment-logs`, { method: 'PUT', body: JSON.stringify(data) }),
};
